const NS = 'SiteFooterLinksWidget';
const CLS = 'siteFooterLinksWidget';

export class SiteFooterLinksWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$sitemapButton = this.$element.find(`.${CLS}-link--sitemap`);
		this.$siteFooterWidget = this.$element.parents('.siteFooterWidget');
		this.$siteFooterSitemapWidget = this.$siteFooterWidget.find('.siteFooterSitemapWidget');

		this.$sitemapButton.on('click', () => {
			this.$siteFooterWidget.trigger(`siteFooterWidget.toggleSiteFooterSitemap`, {});
		});

		this.$element.on(`${CLS}.sitemapButton.toggleClass`, () => {
			if(this.$siteFooterSitemapWidget.attr('data-closed') === 'false') {
				this.$sitemapButton.addClass(`${CLS}-link--sitemap--active`);
			}
			else {
				this.$sitemapButton.removeClass(`${CLS}-link--sitemap--active`);
			}
		});
	}
}
